import apiClient from './client';
import { SystemHealthResponse } from '@/types/system-health';

// O caminho vai sem "/api/v1": o VITE_API_BASE_URL do apiClient já termina
// nele, ao contrário do customTargetingClient, que aponta para a raiz do
// keyvalues.rocketgroup.io e por isso carrega o prefixo em cada chamada.
export const getSystemHealth = async (): Promise<SystemHealthResponse> => {
    const response = await apiClient.get('/system/health');
    return response.data;
};
